import { ArrayField, ArrayFieldApi, useArrayFieldItemApi, useArrayFieldItemState } from 'informed';
import { useRef, useState } from 'react';
import classNames from 'classnames';
import Emoji from '../Emoji';
import moment from 'moment';
import { timeFormatter, TyInput, TyNumberInput } from '@tymbe/ui-forms';
import { getDurationString, maxDuration } from './utils';
import { Button } from '@tymbe/ui-primitives/*';
import { ActionIcon, FavouriteIcon, SocialIcon } from '@tymbe/ui-icons';
import Collapse from '../../../../components/Collapse';
import { ShiftItem } from './types';
import InvitationItem from './InvitationItem';

interface ShiftItemProps {
  onEdit?: (shift: ShiftItem, index: number) => void;
  getInvitations?: () => { id: string, selected: boolean }[];
}

const ShiftListItem = ({ onEdit, getInvitations = () => [] }: ShiftItemProps) => {
  const { values: shift, key, index, initialValue } = useArrayFieldItemState<ShiftItem>();
  const { remove } = useArrayFieldItemApi();
  const [open, setOpen] = useState(false);
  const addInvitationRef = useRef<ArrayFieldApi['addWithInitialValue']>(null);

  const addInvitations = () => {
    const invitations = getInvitations().filter(({ id }) => !shift.invitations?.find((inv => String(inv.id) === String(id))));

    for (const invitation of invitations) {
      addInvitationRef.current?.({
        ...invitation,
        selected: false,
      });
    }
  }

  return (
    <div
      key={key}
      onClick={(e) => {
        // if interactive element
        if (e.target instanceof HTMLElement && !e.target.closest('button, input, select, textarea')) {
          setOpen(!open);
        }
      }}
      className={classNames(
        'grid grid-cols-subgrid col-span-full border border-b-0 last:border-b first:rounded-t-3xl last:rounded-b-3xl border-secondary-transparent-10 px-4 items-center py-1 transition-colors',
        'hover:bg-secondary-transparent-5 hover:cursor-pointer',
        { 'bg-secondary-transparent-5': open },
      )}
    >
      <div className="flex items-center gap-2 h-[72px]">
        <Emoji emoji="🐛" className="size-8 bg-secondary-50" />
        <div>
          <div className="text-secondary-600">{moment(shift?.date).format('L')}</div>
          <div className="text-secondary-500 font-normal">Skladový operátor</div>
        </div>
      </div>
      <div className="flex gap-2.5 items-center text-secondary-500">
        <TyInput simple formatter={timeFormatter} className="w-16" name="startTime" validateWhen={['endTime']} validate={maxDuration} validateOn="change" />
        -
        <TyInput simple formatter={timeFormatter} className="w-16" name="endTime" validateWhen={['startTime']}  validate={maxDuration} validateOn="change" />
        {getDurationString(shift?.startTime, shift?.endTime)}
      </div>
      <div className="text-secondary-500">
        <TyNumberInput name="slots" className="w-32" validate={(value) => Number(value) < Number(shift?.invitations?.length || 0) ? 'Snažíte se pozvat více brigádníků než je volných míst.' : undefined} />
      </div>
      <div>
        {shift?.invitations?.length ?? 0}
      </div>
      <div className="flex items-center gap-2">
        <Button className="text-white bg-secondary-600 p-2.5" onClick={() => addInvitations()} type="button"><SocialIcon name="person_add" className="size-5" /></Button>
        <Button className="border border-secondary-300 p-2.5" onClick={() => onEdit?.({ ...initialValue, ...shift }, index)} type="button"><FavouriteIcon name="mode_edit" className="size-5" /></Button>
        <Button className="border border-red-300 text-red-500 p-2.5" onClick={() => remove()} type="button"><ActionIcon name="delete_outline" className="size-5" /></Button>
      </div>
      <Collapse open={open} className="col-start-3 col-span-3 flex flex-col *:divide-y *:divide-secondary-100">
        <ArrayField name="invitations">
          {({ addWithInitialValue }) => {
            addInvitationRef.current = addWithInitialValue;
            return (
              <ArrayField.Items>
                {(props) => {
                  return (
                    <InvitationItem />
                  );
                }}
              </ArrayField.Items>
            )
          }}
        </ArrayField>
      </Collapse>
      {/* to keep in informed values */}
      <TyInput name="templateId" className="hidden" />
      <TyInput name="date" className="hidden" />
      <TyInput name="contact" className="hidden" />
      <TyInput name="requirements" className="hidden" />
      <TyInput name="utilities" className="hidden" />
      <TyInput name="noPreferences" className="hidden" />
      <TyInput name="menOnly" className="hidden" />
      <TyInput name="womenOnly" className="hidden" />
      <TyInput name="men" className="hidden" />
      <TyInput name="women" className="hidden" />
    </div>
  )
};

export default ShiftListItem;
